import React from 'react';

type Props = {
  icon: JSX.Element;
  label: string;
  value?: string;
  isLink?: boolean;
};

const AddressRow = ({ icon, label, value, isLink = false }: Props) => {
  if (!value) return null;

  return (
    <div className="flex items-center gap-2 mb-2 justify-between border-b pb-2">
      <div className="flex items-center gap-2 text-gray-500">
        {icon}
        <span>{label}</span>
      </div>
      {isLink ? (
        <a
          href={
            label === 'Office Email'
              ? `mailto:${value}`
              : label === 'Office Phone Number'
              ? `tel:${value}`
              : value
          }
          target={label === 'Directions' ? '_blank' : undefined}
          rel={label === 'Directions' ? 'noopener noreferrer' : undefined}
          className={label === 'Directions' ? 'text-blue-600' : 'text-gray-800'}
        >
          {value}
        </a>
      ) : (
        <span>{value}</span>
      )}
    </div>
  );
};

export default AddressRow;
